import React from "react";
import styled from "styled-components";
import LoadingScreen from "./LoadingScreen";
import AssessmentResult from "./AssessmentResult";
import { Scale } from 'react-scaling';

export default function NewSpellingGame({ ...props }) {
    const { children, correct, incorrect, loading, questionLimit, score, qanswers } = props;

    if (loading) return <LoadingScreen />;

    const answeredTotal = (correct?.length || 0) + (incorrect?.length || 0);
    const isFinished = questionLimit > 0 && answeredTotal >= questionLimit;

    // Matches the "AreYouSure" logic from your other games
    const AreYouSureBack = () => {
        if (window.confirm("Are you sure you want to leave? Your progress will not be saved.")) {
            props.onBack();
        }
    };

    return (
        <ApplicationContainer>
            <Scale scaleTo={1720}>
                <ApplicationHeader>
                    <LeftHeader>
                    </LeftHeader>
                    
                    <CenterHeader>
                        <TimerBox>
                            {answeredTotal} / {questionLimit}
                        </TimerBox>
                    </CenterHeader>
                    
                    <RightHeader>
                        {/* Correct/Incorrect removed as requested, replaced with functional Back button */}
                        <div style={{flex: 1}} /> 
                        <Back onClick={AreYouSureBack}>Back</Back>
                    </RightHeader>
                </ApplicationHeader>
            </Scale>

            {!isFinished ? (
                <ContentArea>{children}</ContentArea>
            ) : (
                <AssessmentResult
                    score={score}
                   correct={correct}   // Passing full array for topic processing
                    incorrect={incorrect} 
                    qanswers={qanswers}
                    onBack={props.onBack}
                    feedback={props.feedback}
                    parent={props} // Pass props down so parent.homework_id is accessible
                />
            )}
        </ApplicationContainer>
    );
}

const ApplicationContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background: linear-gradient(180deg, #091220 0%, #1B2735 100%);
`;

const ApplicationHeader = styled.div`
    width: 100%;
    height: 60px;
    background: #683d8c;
    justify-content: space-around;
    display: flex;
`;

const LeftHeader = styled.div`
    width: 30%;
    display: flex;
    justify-content: flex-end;
`;

const RightHeader = styled.div`
    width: 30%;
    display: flex;
    align-items: center;
`;

const CenterHeader = styled.div`
    width: 30%;
    display: flex;
    justify-content: center;
`;

const TimerBox = styled.div`
    width: 200px;
    height: 80px;
    background: #ef3e37;
    text-align: center;
    font-size: 3em;
    font-weight: 600;
    color: #fff;
    line-height: 80px;
    margin-top: 0px;
    border-radius: 0px 0px 15px 15px;
    z-index: 11;
`;

const Score = styled.div`
    width: 200px;
    height: 40px;
    margin-top: 10px;
    background: #4b2e6b;
    text-align: center;
    font-size: 1.8em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-right: 20px;
    border-radius: 20px;
`;

const Back = styled.div`
    width: 150px;
    height: 40px;
    background: #4b2e6b;
    user-select: none;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 20px;
    cursor: pointer;
    &:hover {
        background: #5a3882;
    }
`;

const ContentArea = styled.div`
    flex: 1;
    position: relative;
`;